import ModifPositioningDeviceTypeModal from './modif-positioning-device-type-modal.vue'
export default ModifPositioningDeviceTypeModal
